var transformLogicalInlineProperty = function transformLogicalInlineProperty(fallbackStyles) {
  return function (value) {
    return {
      ltr: "".concat(fallbackStyles.ltrFallbackStyle, ":").concat(value, ";"),
      rtl: "".concat(fallbackStyles.rtlFallbackStyle, ":").concat(value, ";")
    };
  };
};

export { transformLogicalInlineProperty };
